import React, { forwardRef } from 'react'
import MaskedInput from 'react-text-mask';

// mask/placeholder are set by this component after the spread, so callers
// cannot supply them — omit to keep them from being required props
type InputPhoneProps = Omit<React.ComponentProps<typeof MaskedInput>, 'mask' | 'placeholder'>;

const InputPhone = forwardRef<React.ElementRef<typeof MaskedInput>, InputPhoneProps>((props, ref) => {
  return (
    <MaskedInput
      {...props}
      ref={ref}
      className={'phone_input ' + props.className}
      mask={
        ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      }
      placeholder='(000) 000-0000'
    />
  )
});

export default InputPhone;
